// src/components/LicenseApprovalModal.js
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';
import { FaTimes, FaCheck, FaBan, FaInfoCircle, FaUser, FaCalendarAlt, FaClipboardList, FaArrowRight } from 'react-icons/fa';

export default function LicenseApprovalModal({ request, onClose, onSuccess }) {
    const proposedTotal = request.licencas_atuais + request.licencas_solicitadas;
    
    // UX: Estado de ação controla qual formulário exibir na coluna da direita
    const [acao, setAcao] = useState('aprovada'); // 'aprovada' | 'rejeitada'
    const [newTotal, setNewTotal] = useState(proposedTotal);
    const [rejectionReason, setRejectionReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            let payload = { decisao: acao };

            if (acao === 'aprovada') {
                if (newTotal <= request.licencas_atuais) {
                    toast.warn('O novo total de licenças deve ser maior que o atual.');
                    setIsSubmitting(false);
                    return;
                }
                payload.novo_total_licencas = newTotal;
            } else {
                if (!rejectionReason.trim()) {
                    toast.warn('O motivo da rejeição é obrigatório.');
                    setIsSubmitting(false);
                    return;
                }
                payload.motivo_rejeicao = rejectionReason;
            }

            const token = localStorage.getItem('token');
            await api.put(`/api/system-hub/licensing-requests/${request.id}/decide`, payload, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            toast.success(`Solicitação ${acao === 'aprovada' ? 'Aprovada' : 'Rejeitada'} com sucesso!`);
            onSuccess(); 
        } catch (error) {
            toast.error(error?.response?.data?.error || "Falha ao processar a decisão.");
            setIsSubmitting(false);
        }
    };

    if (!request) return null;

    return (
        <div className="modal-overlay" style={{ backdropFilter: 'blur(4px)', backgroundColor: 'rgba(15, 23, 42, 0.6)' }}>
            <div className="modal-content" style={{ maxWidth: '900px', width: '95%', padding: 0, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
                
                {/* HEADER */}
                <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 30px', backgroundColor: '#ffffff', borderBottom: '1px solid #e2e8f0' }}>
                    <h2 style={{ margin: 0, color: '#0f172a', fontSize: '1.3rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ background: '#eff6ff', padding: '8px', borderRadius: '8px', display: 'flex' }}>
                            <FaClipboardList color="#101C5D" size={18} />
                        </div>
                        Decisão de Upgrade de Licenças
                    </h2>
                    <button onClick={onClose} disabled={isSubmitting} style={{ background: 'transparent', border: 'none', fontSize: '1.2rem', cursor: 'pointer', color: '#94a3b8', transition: 'color 0.2s' }} title="Fechar">
                        <FaTimes />
                    </button>
                </header>

                {/* CORPO DO MODAL - GRID 2 COLUNAS */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: '380px' }}>
                    
                    {/* COLUNA ESQUERDA: CONTEXTO (Somente Leitura) */}
                    <div style={{ padding: '30px', backgroundColor: '#f8fafc', borderRight: '1px solid #e2e8f0' }}>
                        <h4 style={{ margin: '0 0 20px 0', color: '#64748b', textTransform: 'uppercase', fontSize: '0.80rem', letterSpacing: '1px', fontWeight: '700' }}>
                            Contexto do Pedido
                        </h4>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div>
                                <small style={{ color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600' }}><FaUser /> Cliente Solicitante</small>
                                <p style={{ margin: '4px 0 0 0', fontWeight: 'bold', fontSize: '1.15rem', color: '#0f172a' }}>{request.nome_empresa}</p>
                                <p style={{ margin: '2px 0 0 0', color: '#475569', fontSize: '0.9rem' }}>por {request.solicitante_nome}</p>
                            </div>
                            
                            <div>
                                <small style={{ color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600' }}><FaCalendarAlt /> Data da Solicitação</small>
                                <p style={{ margin: '4px 0 0 0', color: '#334155', fontWeight: '500' }}>{new Date(request.data_solicitacao).toLocaleString('pt-BR')}</p>
                            </div>

                            {/* Card visual para o salto de licenças */}
                            <div style={{ background: '#ffffff', padding: '20px', borderRadius: '10px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b', fontWeight: '600' }}>ATUAL</p>
                                    <p style={{ margin: '4px 0 0', fontSize: '1.4rem', fontWeight: 'bold', color: '#334155' }}>{request.licencas_atuais}</p>
                                </div>
                                <div style={{ color: '#101C5D', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: '0.8rem', fontWeight: 'bold', background: '#e0e7ff', padding: '2px 8px', borderRadius: '12px', marginBottom: '4px' }}>+{request.licencas_solicitadas}</span>
                                    <FaArrowRight />
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b', fontWeight: '600' }}>PROPOSTO</p>
                                    <p style={{ margin: '4px 0 0', fontSize: '1.4rem', fontWeight: 'bold', color: '#101C5D' }}>{proposedTotal}</p>
                                </div>
                            </div>

                            {request.justificativa && (
                                <div>
                                    <small style={{ color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600' }}><FaInfoCircle /> Justificativa Anexada</small>
                                    <p style={{ margin: '6px 0 0 0', fontStyle: 'italic', color: '#475569', background: '#f1f5f9', padding: '12px 15px', borderRadius: '6px', borderLeft: '3px solid #cbd5e1', fontSize: '0.95rem' }}>
                                        "{request.justificativa}"
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* COLUNA DIREITA: AÇÃO (Formulário interativo) */}
                    <div style={{ padding: '30px', backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column' }}>
                        <h4 style={{ margin: '0 0 20px 0', color: '#64748b', textTransform: 'uppercase', fontSize: '0.80rem', letterSpacing: '1px', fontWeight: '700' }}>
                            Ação Administrativa
                        </h4>

                        {/* TOGGLE APPROVE/REJECT */}
                        <div style={{ display: 'flex', background: '#f1f5f9', borderRadius: '8px', padding: '4px', marginBottom: '25px', border: '1px solid #e2e8f0' }}>
                            <button 
                                onClick={() => setAcao('aprovada')}
                                style={{ flex: 1, padding: '10px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'all 0.2s', background: acao === 'aprovada' ? '#ffffff' : 'transparent', color: acao === 'aprovada' ? '#16a34a' : '#64748b', boxShadow: acao === 'aprovada' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}
                            >
                                <FaCheck /> Aprovar Pedido
                            </button>
                            <button 
                                onClick={() => setAcao('rejeitada')}
                                style={{ flex: 1, padding: '10px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'all 0.2s', background: acao === 'rejeitada' ? '#ffffff' : 'transparent', color: acao === 'rejeitada' ? '#dc2626' : '#64748b', boxShadow: acao === 'rejeitada' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}
                            >
                                <FaBan /> Rejeitar Pedido
                            </button>
                        </div>

                        {/* ÁREA DINÂMICA DO FORMULÁRIO */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            {acao === 'aprovada' ? (
                                <div style={{ animation: 'fadeIn 0.3s' }}>
                                    <label style={{ display: 'block', color: '#334155', fontWeight: '600', marginBottom: '8px', fontSize: '0.95rem' }}>
                                        Confirmar Novo Total de Licenças
                                    </label>
                                    <input 
                                        type="number" 
                                        value={newTotal} 
                                        onChange={(e) => setNewTotal(parseInt(e.target.value, 10))}
                                        style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '1.4rem', fontWeight: 'bold', color: '#16a34a', outline: 'none', transition: 'border-color 0.2s', boxSizing: 'border-box' }}
                                        onFocus={(e) => e.target.style.borderColor = '#16a34a'}
                                        onBlur={(e) => e.target.style.borderColor = '#cbd5e1'}
                                        min={request.licencas_atuais + 1}
                                    />
                                    <p style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '10px', lineHeight: '1.4' }}>
                                        O limite da empresa será ajustado imediatamente para este valor e novas chaves de licença serão geradas.
                                    </p>
                                </div>
                            ) : (
                                <div style={{ animation: 'fadeIn 0.3s' }}>
                                    <label style={{ display: 'block', color: '#334155', fontWeight: '600', marginBottom: '8px', fontSize: '0.95rem' }}>
                                        Motivo da Rejeição <span style={{ color: '#ef4444' }}>*</span>
                                    </label>
                                    <textarea 
                                        value={rejectionReason} 
                                        onChange={(e) => setRejectionReason(e.target.value)}
                                        placeholder="Informe o motivo para transparência com o cliente..."
                                        rows="5"
                                        style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '0.95rem', color: '#0f172a', outline: 'none', transition: 'border-color 0.2s', resize: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
                                        onFocus={(e) => e.target.style.borderColor = '#dc2626'}
                                        onBlur={(e) => e.target.style.borderColor = '#cbd5e1'}
                                    />
                                    <p style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '10px' }}>
                                        Esta mensagem será enviada como notificação ao usuário solicitante.
                                    </p>
                                </div>
                            )}
                        </div>

                        {/* BOTÃO DE CONFIRMAÇÃO */}
                        <div style={{ marginTop: 'auto', paddingTop: '20px' }}>
                            <button 
                                onClick={handleSubmit} 
                                disabled={isSubmitting}
                                style={{ 
                                    width: '100%', padding: '16px', border: 'none', borderRadius: '8px', 
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer', fontWeight: 'bold', fontSize: '1rem', 
                                    color: '#ffffff', transition: 'all 0.2s', 
                                    background: acao === 'aprovada' ? '#16a34a' : '#dc2626', 
                                    opacity: isSubmitting ? 0.7 : 1,
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                                }}
                            >
                                {isSubmitting ? 'Processando no Banco...' : (acao === 'aprovada' ? 'Efetivar Aprovação e Atualizar Limites' : 'Confirmar Rejeição do Pedido')}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(5px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
}